import clsx from 'clsx';
import { ScaleLinear } from 'd3';

import { LinePlot } from '../line-plot/LinePlot';
import styles from './CumulativeReturn.module.scss';

export interface CumulativeReturnProps {
  ts: {
    index: number;
    value: number;
  }[];
  xScale: ScaleLinear<number, number>;
  yScale: ScaleLinear<number, number>;
  id: string;
}

export const CumulativeReturn = ({
  ts,
  xScale,
  yScale,
  id,
}: CumulativeReturnProps) => {
  return (
    <>
      <g clipPath={`url(#hl-clip-upper-${id})`}>
        <g
          key={`plot-positive`}
          role="group"
          aria-label="Positive cumulative return"
        >
          <LinePlot
            className={clsx(styles.styledLinePlot, styles.typePositive)}
            ts={ts}
            scaleX={xScale}
            scaleY={yScale}
          />
        </g>
      </g>
      <g clipPath={`url(#hl-clip-bottom-${id})`}>
        <g
          key={`plot-negative`}
          role="group"
          aria-label="Negative cumulative return"
        >
          <LinePlot
            className={clsx(styles.styledLinePlot, styles.typeNegative)}
            ts={ts}
            scaleX={xScale}
            scaleY={yScale}
          />
        </g>
      </g>
    </>
  );
};
